<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>Notiz</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<h2 v-if="subTitle">{{ subTitle }}</h2>
			<b-textarea v-model="notice" :rows="10"/>
			<div class="mt-2 font-size-smaller">Deine Notizen sind nur für dich sichtbar.</div>
		</main>
		<footer>
			<Button
				v-if="hasNotice"
				text="Notiz löschen"
				icon="close"
				secondary
				:disabled="saving"
				:loading="saving"
				class="mr-2"
				@click="save('')"
			/>
			<Button
				text="Notiz speichern"
				icon="checkmark"
				:disabled="saving"
				:loading="saving"
				class="mt-2 mt-md-0"
				@click="save(notice)"
			/>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Button from "@/vue/common/Button";
import CustomerNotice from "@/api/customer/job-profile/applicant/Notice";
import ApplicationNotice from "@/api/application/job-profile/Notice";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job-result/notice";
import {isEmptyOrNull} from "@/helper/String";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {

	components: {
		Button,
		Icon,
	},

	data ()
	{
		return {
			saving: false,
		};
	},

	computed: {
		...mapState('jobResult/notice', [
			'show',
			'jobProfileId',
			'applicant',
			'type',
			'subTitle',
		]),
		...mapState('layout', ['fanLevelClasses']),
		notice: {
			get ()
			{
				return this.$store.state.jobResult.notice.notice;
			},

			set (value)
			{
				this.setNotice(value);
			}
		},
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in'],
			});
		},
		hasNotice ()
		{
			return this.notice && !isEmptyOrNull(this.notice);
		}
	},

	methods: {
		...mapActions('jobResult/notice', [
			'close'
		]),
		...mapMutations('jobResult/notice', [
			'setNotice'
		]),
		async save (notice)
		{
			Event.push(
				new EventData()
					.setEvent(Event.NOTICE)
					.setAction('Speichern')
			);

			this.saving = true;

			this.notice = notice;

			try
			{
				if (this.type === 'customer')
				{
					await new CustomerNotice()
						.setJobProfileId(this.jobProfileId)
						.setPseudonymId(this.applicant.id)
						.setNotice(notice)
						.call();
				}
				else
				{
					await new ApplicationNotice()
						.setJobProfileId(this.jobProfileId)
						.setNotice(notice)
						.call();
				}

				this.close();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
	},
}
</script>
